import Vuex from 'vuex';

// Source: https://next.vuex.vuejs.org/guide/hot-reload.html#dynamic-module-hot-reloading
function loadModules () {
  const context = require.context('./modules', true, /store\/([a-z_-]+)\.js$/i);
  const modules = context
    .keys()
    .map((key) => ({ key, name: key.match(/([a-z_-]+)\.js$/i)[1] }))
    .reduce(
      (modules, { key, name }) => ({
        ...modules,
        [name]: context(key).default
      }),
      {}
    );
  return { context, modules };
}

const debug = process.env.NODE_ENV !== 'production';
const { context, modules } = loadModules();

// TODO: Add explicit logging after Vue 3 upgrade until Vuex support returns to Vue Devtools
// https://v3.vuejs.org/guide/installation.html#vue-devtools
// if (debug) plugins.push(createLogger());
const store = new Vuex.Store({
  modules,
  strict: debug
});

if (module.hot) {
  module.hot.accept(context.id, () => {
    const { modules } = loadModules();
    store.hotUpdate({
      modules
    });
  });
}

// TODO: Replace with built-in function when upgrading to Vuex 4
export function useStore () { return store; }

export default store;
